<template>
	<div class="common-avatar">
		<avatar :image="image" :isTeam="isTeam" :isMember="isMember" :width="width" :clickable="clickable" @click="onAvatarClick"></avatar>
	</div>
</template>

<script>
import Avatar from '@/components/Avatar'

export default {
	name: 'CommonAvatar',
	components: {
		Avatar,
	},
	props: {
		width: {
			type: Number,
			default: 90,
		},
		name: {
			type: String,
			default: '',
		},
		image: {
			type: String,
			default: '',
		},
		staffId: {
			type: String,
			default: '',
		},
		teamId: {
			type: String,
			default: '',
		},
		isTeam: {
			type: Boolean,
			default: false,
		},
		isMember: {
			type: Boolean,
			default: false,
		},
		clickable: {
			type: Boolean,
			default: true,
		},
		fromRoute: {
			type: String,
			default: '',
		}
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	computed: {
	},
	methods: {
		onAvatarClick: function() {
			// 自アバタークリックはマイページへ
			if (this.staffId && this.staffId === this.$store.state.auth.id) {
				this.$router.push({ name: 'my-page' });
				return;
			}

			let selectModal = {
				'image': this.image,
				'staffId': this.staffId,
				'teamId': this.teamId,
				'isTeam': this.isTeam,
				'name': this.name,
			};

			this.$store.commit('basic', {
				key: 'selectModal',
				value: selectModal,
			});

			this.$store.commit('basic', {
				key: 'isSelectModalActive',
				value: true,
			});
			
			if (this.fromRoute === 'team-talk') {
				this.$store.commit('basic', {
					key: 'teamIdForTeamTalk',
					value: this.teamId,
				});
			} else {
				this.$store.commit('basic', {
					key: 'teamIdForTeamTalk',
					value: '',
				});
			}
		},
	},
}
</script>

<style lang="scss">

</style>
